import { useProfile } from '@/hooks';
import { LoadingPage } from '@/pages';
import { managerV1BaseUrl } from '@/utils';
import { ReactNode, useEffect } from 'react';

export function WithGuttagekontoBenutzerrecht({
  children,
}: {
  children: ReactNode;
}) {
  const { manager } = useProfile();
  const hasGuttagekontoRecht = manager?.rechte.mitarbeiter.guttagekonto;

  const NavigateToV1 = () => {
    useEffect(() => {
      window.location.replace(managerV1BaseUrl);
    }, []);
    return <LoadingPage />;
  };

  if (!hasGuttagekontoRecht) {
    return <NavigateToV1 />;
  }

  return children;
}
